//------------- REACT IMPORT ---------------//
import React, { useEffect, useState } from "react";
//---------- FONTAWESOME IMPORT ------------//
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBed, faCalendarAlt, faEllipsisVertical, faMars, faSearch, faVenus } from "@fortawesome/free-solid-svg-icons";
//-------- BOOTSTRAP ITEMS IMPORT ----------//
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Image, Row } from "react-bootstrap";
//-------- HEADER COMPONENT IMPORT ---------//
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
//------------ CONSTANTS IMPORT ------------//
import * as Constants from '../../../Helper/constants/constants';
//-------------- IMAGES IMPORT -------------//
import { Calendar, Calender, Card1, Card2, Card3, Card4, SearchFilter } from "../../../../assets/images";
//-------------- MODALS IMPORT -------------//
import TaskModal from "../../Modals/TaskModal/index";
import FilterModal from "../../Modals/FilterModal";
import PaginationComponent from "../../CommanComponents/Pagination";
import PatientListFunctions from "./functions";
import { dateFormat } from "../../../Helper/General";
import { useLocation } from "react-router-dom";



const PatientList = () => {
    const {
        setShowFilterModal,
        showFilterModal,
        showLogin,
        setShowLogin,
        searchInput,
        handleChange,
        getPatientListing,
        patientListing,
        navigate,
    } = PatientListFunctions();

    const loaction = useLocation();
    const [breadcrumData, setbreadcrumData] = useState(['Dashboard']);
    var breadcrumItem = 'Patient List';

    useEffect(() => {
        if (loaction && loaction.state) {
            let array = [...breadcrumData]
            let name = loaction.state.name
            if(array){
                array.push(name)
            }
            else{
                array.push('Ward')
            }
            setbreadcrumData(array);
        }
        getPatientListing();
    }, []);


    return (
        <>
            <div className="patient_list_screen">
                <WithoutImageHeader
                    header={Constants.PATIENT_LIST_HEADER}
                    breadcrumData={breadcrumData}
                    breadcrumItem={breadcrumItem}
                />
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <div className="patient_details">
                                <div className="search_section">
                                    <div className="search_area">
                                        <Form>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Search"
                                                    value={searchInput}
                                                    onChange={handleChange}
                                                />
                                                <a href="javascript:;">
                                                    <div className="icon">
                                                        <FontAwesomeIcon icon={faSearch} />
                                                    </div>
                                                </a>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                    <a href="javascript:;">
                                        <div className="filter_area">
                                            <div className="img_area" onClick={() => setShowFilterModal(true)}>
                                                <Image src={SearchFilter} alt="..." />
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="active_area">
                                    <p>Active Patient : 4</p>
                                </div>
                                {
                                    patientListing && patientListing.length > 0 ?
                                        patientListing.map((item, i) => {
                                            return (
                                                <Card key={i}>
                                                    <Card.Body onClick={() => navigate(`/patientDetails`, { state: { id: item.id, pageParams: breadcrumData , name : item.name} })}>
                                                        <div className="card_left">
                                                            <div className="img_area">
                                                                <Card.Img variant="left" src={Card1} alt="..." />
                                                            </div>
                                                        </div>
                                                        <div className="card_right">
                                                            <div className="personal_data">
                                                                <div className="name_number_area">
                                                                    <div className="data">
                                                                        <h3>{item.name}</h3>
                                                                        <span>
                                                                            {
                                                                                item.uh_id ?
                                                                                    <p>MR : {item.uh_id}</p>
                                                                                    :
                                                                                    null
                                                                            }

                                                                            <Dropdown>
                                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                                </Dropdown.Toggle>

                                                                                <Dropdown.Menu>
                                                                                    <Dropdown.Item href="javascript:;">Admitted</Dropdown.Item>
                                                                                    <Dropdown.Item href="javascript:;">Under Treatment</Dropdown.Item>
                                                                                    <Dropdown.Item href="javascript:;">Critical</Dropdown.Item>
                                                                                    <Dropdown.Item href="javascript:;">Discharged</Dropdown.Item>
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </span>
                                                                    </div>

                                                                </div>
                                                                <p><span>Cardiology</span></p>
                                                                <div className="gender_area">
                                                                    {
                                                                        item.gender ?
                                                                            <p><FontAwesomeIcon icon={faVenus} className="gender_icon" />{item.gender}</p>
                                                                            :
                                                                            null
                                                                    }
                                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                                                </div>
                                                                <div className="date_information">
                                                                    {
                                                                        item.created ?
                                                                            <div className="date">
                                                                                <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                                                <p>{dateFormat(item.created)}</p>
                                                                            </div>
                                                                            :
                                                                            null

                                                                    }
                                                                    {
                                                                        item.patient_status ?
                                                                            <div className="badge success" onClick={() => setShowLogin(true)}>
                                                                                <p>{item.patient_status}</p>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                    {/* <div className="badge" onClick={() => setShowLogin(true)}>
                                                                        <p>Under Treatment</p>
                                                                    </div>
                                                                    <div className="badge critical" onClick={() => setShowLogin(true)}>
                                                                        <p>Critical</p>
                                                                    </div> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            )
                                        })
                                        :
                                        null
                                }

                                {/* <Card>
                                    <Card.Body>
                                        <div className="card_left">
                                            <div className="img_area">
                                                <Card.Img variant="left" src={Card2} alt="..." />
                                            </div>
                                        </div>
                                        <div className="card_right">
                                            <div className="personal_data">
                                                <div className="name_number_area">
                                                    <div className="data">
                                                        <h3>Peter Thomas</h3>
                                                        <span>MR : 198293
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">Admitted</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Under Treatment</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Critical</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Discharged</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    </div>

                                                </div>

                                                <p><span>Cardiology</span></p>
                                                <div className="gender_area">
                                                    <p><FontAwesomeIcon icon={faMars} className="gender_icon" />Male</p>
                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                                </div>
                                                <div className="date_information">
                                                    <div className="date">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                        <p>5 July, 2023</p>
                                                    </div>

                                                    <div className="badge critical" onClick={() => setShowLogin(true)}>
                                                        <p>Critical</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card> */}

                                {/* <Card>
                                    <Card.Body>
                                        <div className="card_left">
                                            <div className="img_area">
                                                <Card.Img variant="left" src={Card3} alt="..." />
                                            </div>
                                        </div>
                                        <div className="card_right">
                                            <div className="personal_data">
                                                <div className="name_number_area">
                                                    <div className="data">
                                                        <h3>Peter Thomas</h3>
                                                        <span>MR : 198293
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">Admitted</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Under Treatment</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Critical</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Discharged</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    </div>

                                                </div>
                                                <p><span>Cardiology</span></p>
                                                <div className="gender_area">
                                                    <p><FontAwesomeIcon icon={faMars} className="gender_icon" />Male</p>
                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                                </div>
                                                <div className="date_information">
                                                    <div className="date">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                        <p>5 July, 2023</p>
                                                    </div>
                                                    <div className="badge critical" onClick={() => setShowLogin(true)}>
                                                        <p>Critical</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card> */}

                                {/* <Card>
                                    <Card.Body>
                                        <div className="card_left">
                                            <div className="img_area">
                                                <Card.Img variant="left" src={Card4} alt="..." />
                                            </div>
                                        </div>
                                        <div className="card_right">
                                            <div className="personal_data">
                                                <div className="name_number_area">
                                                    <div className="data">
                                                        <h3>Robert William</h3>
                                                        <span>MR : 198293
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">Admitted</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Under Treatment</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Critical</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Discharged</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    </div>

                                                </div>
                                                <p><span>Cardiology</span></p>
                                                <div className="gender_area">
                                                    <p><FontAwesomeIcon icon={faVenus} className="gender_icon" />Female</p>
                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                                </div>
                                                <div className="date_information">
                                                    <div className="date">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                        <p>5 July, 2023</p>
                                                    </div>
                                                    <div className="badge success" onClick={() => setShowLogin(true)}>
                                                        <p>Admitted</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card> */}

                                {/* <Card>
                                    <Card.Body>
                                        <div className="card_left">
                                            <div className="img_area">
                                                <Card.Img variant="left" src={Card1} alt="..." />
                                            </div>
                                        </div>
                                        <div className="card_right">
                                            <div className="personal_data">
                                                <div className="name_number_area">
                                                    <div className="data">
                                                        <h3>Robert William</h3>
                                                        <span>MR : 198293
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">Admitted</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Under Treatment</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Critical</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Discharged</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    </div>

                                                </div>
                                                <p><span>Cardiology</span></p>
                                                <div className="gender_area">
                                                    <p><FontAwesomeIcon icon={faVenus} className="gender_icon" />Female</p>
                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                                </div>
                                                <div className="date_information">
                                                    <div className="date">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                        <p>5 July, 2023</p>
                                                    </div>
                                                    <div className="badge" onClick={() => setShowLogin(true)}>
                                                        <p>Under Treatment</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body>
                                        <div className="card_left">
                                            <div className="img_area">
                                                <Card.Img variant="left" src={Card2} alt="..." />
                                            </div>
                                        </div>
                                        <div className="card_right">
                                            <div className="personal_data">
                                                <div className="name_number_area">
                                                    <div className="data">
                                                        <h3>Peter Thomas</h3>
                                                        <span>MR : 198293
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">Admitted</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Under Treatment</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Critical</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Discharged</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    </div>

                                                </div>
                                                <p><span>Cardiology</span></p>
                                                <div className="gender_area">
                                                    <p><FontAwesomeIcon icon={faMars} className="gender_icon" />Male</p>
                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                                </div>
                                                <div className="date_information">
                                                    <div className="date">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                        <p>5 July, 2023</p>
                                                    </div>
                                                    <div className="badge critical" onClick={() => setShowLogin(true)}>
                                                        <p>Critical</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body>
                                        <div className="card_left">
                                            <div className="img_area">
                                                <Card.Img variant="left" src={Card3} alt="..." />
                                            </div>
                                        </div>
                                        <div className="card_right">
                                            <div className="personal_data">
                                                <div className="name_number_area">
                                                    <div className="data">
                                                        <h3>Peter Thomas</h3>
                                                        <span>MR : 198293
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">Admitted</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Under Treatment</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Critical</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Discharged</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    </div>

                                                </div>
                                                <p><span>Cardiology</span></p>
                                                <div className="gender_area">
                                                    <p><FontAwesomeIcon icon={faMars} className="gender_icon" />Male</p>
                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                                </div>
                                                <div className="date_information">
                                                    <div className="date">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                        <p>5 July, 2023</p>
                                                    </div>
                                                    <div className="badge critical" onClick={() => setShowLogin(true)}>
                                                        <p>Critical</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body>
                                        <div className="card_left">
                                            <div className="img_area">
                                                <Card.Img variant="left" src={Card4} alt="..." />
                                            </div>
                                        </div>
                                        <div className="card_right">
                                            <div className="personal_data">
                                                <div className="name_number_area">
                                                    <div className="data">
                                                        <h3>Robert William</h3>
                                                        <span>MR : 198293
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item href="javascript:;">Admitted</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Under Treatment</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Critical</Dropdown.Item>
                                                                    <Dropdown.Item href="javascript:;">Discharged</Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </span>
                                                    </div>

                                                </div>
                                                <p><span>Cardiology</span></p>
                                                <div className="gender_area">
                                                    <p><FontAwesomeIcon icon={faVenus} className="gender_icon" />Female</p>
                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #05</p>
                                                </div>
                                                <div className="date_information">
                                                    <div className="date">
                                                        <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                        <p>5 July, 2023</p>
                                                    </div>
                                                    <div className="badge critical" onClick={() => setShowLogin(true)}>
                                                        <p>Critical</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card> */}
                            </div>

                            {showLogin ? <TaskModal show={showLogin} close={() => setShowLogin(false)} /> : null}

                        </Col>
                    </Row>
                </Container>

                {
                    showFilterModal ? (
                        <FilterModal show={showFilterModal} close={() => setShowFilterModal(false)} />
                    ) : null
                }

            </div >
            <PaginationComponent />
        </>
    )
}

export default PatientList;